import React, { useEffect, useState } from 'react';
import { Button, Radio, Space } from 'antd';
import styles from './exploreResult.module.sass';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

const TypeFilter = ({ filters, onSubmit, onReset, confirm, status }) => {
  const [typeFilter, setTypeFilter] = useState(
    filters.type ? filters.type : '',
  );

  useEffect(() => {
    setTypeFilter(filters.type ? filters.type : '');
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleReset = () => {
    confirm();
    setTypeFilter('');
    onReset();
  };

  const handleSubmit = () => {
    confirm();
    onSubmit(typeFilter);
    incrementUIRequestsCounter();
  };

  return (
    <div className={styles.typeFilter}>
      <Radio.Group
        onKeyDown={(e) => e.stopPropagation()}
        onChange={(e) => {
          setTypeFilter(e.target.value);
        }}
        value={typeFilter}
      >
        <Space direction="vertical">
          <Radio value="A">A</Radio>
          <Radio value="AAAA">AAAA</Radio>
          <Radio value="NS">NS</Radio>
          <Radio value="MX">MX</Radio>
          <Radio value="CNAME">CNAME</Radio>
          <Radio value="PTR">PTR</Radio>
        </Space>
      </Radio.Group>

      <div className={styles.typeFilterActions}>
        <Button
          type="primary"
          role="search"
          onClick={handleSubmit}
          style={{}}
          size="small"
        >
          Search
        </Button>
        <Button role="reset" type="link" onClick={handleReset} size="small">
          Clear
        </Button>
      </div>
    </div>
  );
};

export default TypeFilter;
